import styles from "./custom-input-switch.module.scss";

const CustomInputSwitch = ({ label, value, onChange, optionLeft = "No", optionRight = "Sí", customStyles, col = 12 }) => {
	const colClass = col === 3 ? styles.col3 : col === 6 ? styles.col6 : styles.col12;

	return (
		<div className={`${styles.field} ${colClass}`}>
			{label && <label className={styles.label}>{label}</label>}
			<div className={`${styles.switchContainer} ${value ? styles.active : ""}`} style={customStyles} onClick={() => onChange(!value)}>
				<div className={styles.options}>
					<span className={`${styles.option} ${!value ? styles.selected : ""}`}>{optionLeft}</span>
					<span className={`${styles.option} ${value ? styles.selected : ""}`}>{optionRight}</span>
				</div>
				<div className={`${styles.slider} ${value ? styles.right : styles.left}`} />
			</div>
		</div>
	);
};

export default CustomInputSwitch;
